import script from "./ChartLabels.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChartLabels.vue?vue&type=script&lang=ts&setup=true"

import "./ChartLabels.vue?vue&type=style&index=0&id=3165b368&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3165b368"]])

export default __exports__